module.exports = __webpack_public_path__ + "img/sp-1.03856359.png";